import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59a086c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "top" }
const _hoisted_2 = { id: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "buffer-decoration" }, ">", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InteractiveText = _resolveComponent("InteractiveText")!

  return (_openBlock(), _createElementBlock("div", {
    id: "wrapper",
    ref: "wrapper",
    class: _normalizeClass({'dark-mode': _ctx.darkMode})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", {
        id: "text-console",
        tabindex: "-1",
        ref: "textConsole",
        class: _normalizeClass({'dark-mode': _ctx.darkMode})
      }, [
        _createVNode(_component_InteractiveText, {
          content: _ctx.text,
          onTokenSelect: _ctx.addToBuffer
        }, null, 8, ["content", "onTokenSelect"])
      ], 2)
    ]),
    _createElementVNode("div", {
      id: "bottom",
      class: _normalizeClass({'dark-mode': _ctx.darkMode})
    }, [
      _createElementVNode("div", {
        id: "verbs",
        class: _normalizeClass({'dark-mode': _ctx.darkMode})
      }, [
        _createVNode(_component_InteractiveText, {
          content: _ctx.verbs,
          onTokenSelect: _ctx.addToBuffer
        }, null, 8, ["content", "onTokenSelect"])
      ], 2),
      _createElementVNode("div", {
        id: "text-buffer",
        class: _normalizeClass({'dark-mode': _ctx.darkMode})
      }, [
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.enterCommand()), ["prevent"]))
        }, [
          _hoisted_3,
          _createTextVNode(" "),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass({'dark-mode': _ctx.darkMode}),
            type: "text",
            id: "buffer-text",
            ref: "bufferInput",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.buffer) = $event))
          }, null, 2), [
            [_vModelText, _ctx.buffer]
          ])
        ], 32),
        _createElementVNode("div", {
          id: "interface",
          class: _normalizeClass({'dark-mode': _ctx.darkMode})
        }, [
          _createElementVNode("button", {
            id: "clear-button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearBuffer()))
          }, "C"),
          _createElementVNode("button", {
            id: "enter-button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.enterCommand()))
          }, "⏎")
        ], 2)
      ], 2)
    ], 2)
  ], 2))
}